import afUsercentricsConsentArray from "../../../Assets/afUsercentric";
//Checking whether walls.io was accepted as a service
window.addEventListener('load', function(event) {
    let wallsio = false;
    const thirdPartyServices = afUsercentricsConsentArray();
    const thirdPartyServicesLength = thirdPartyServices.length;
    for (let i = 0; i < thirdPartyServicesLength; i++) {
        if (thirdPartyServices[i].name === "walls.io" && thirdPartyServices[i].consent.status === true) {
            wallsio = true;
        }
    }
    //In case wallsio is accepted as a service all data protection messages for it should be deleted
    if (wallsio === true) {
        const wallsioPlaceholders = document.querySelectorAll('.social-wall-content-wrapper .social-wall-external-content');
        const wallsioPlaceholdersMessages = document.querySelectorAll('.social-wall-content-wrapper .af-accept-wallsio-message');
        const wallsioPlaceholdersLength = wallsioPlaceholders.length;
        for (let i = 0; i < wallsioPlaceholdersLength; i++) {
            wallsioPlaceholders[i].className = "af-group-wallsio-external-content";
            wallsioPlaceholdersMessages[i].parentElement.removeChild(wallsioPlaceholdersMessages[i]);
        }
    }
});
